// ---- Shared-link encoding ----
// The wishlist is localStorage-only (no backend), so "sharing" works by
// encoding a snapshot of the current items directly into the URL. Whoever
// opens that link sees a read-only view of that snapshot, with the option
// to save any item into their own (separate) wishlist.

function encodeShareData(items) {
  const json = JSON.stringify(items);
  return btoa(encodeURIComponent(json));
}

function decodeShareData(encoded) {
  try {
    const json = decodeURIComponent(atob(encoded));
    const items = JSON.parse(json);
    return Array.isArray(items) ? items : null;
  } catch (err) {
    console.error('Could not decode shared wishlist:', err);
    return null;
  }
}

function getSharedItemsFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const encoded = params.get('shared');
  if (!encoded) return null;
  return decodeShareData(encoded);
}

// ---- Rendering ----

function renderWishlistPage() {
  const grid = document.querySelector('.wishlist-page [ref="grid"]');
  const emptyState = document.querySelector('.wishlist-page [ref="emptyState"]');
  const sharedBanner = document.querySelector('.wishlist-page [ref="sharedBanner"]');
  const heading = document.querySelector('.wishlist-page [ref="heading"]');
  const shareBtn = document.querySelector('.wishlist-page [ref="shareBtn"]');
  if (!grid || !window.AhfWishlist) return;

  const sharedItems = getSharedItemsFromUrl();
  const isSharedView = sharedItems !== null;

  if (sharedBanner) sharedBanner.hidden = !isSharedView;
  if (shareBtn) shareBtn.hidden = isSharedView;
  if (heading && isSharedView) heading.textContent = 'Shared Wishlist';

  const items = isSharedView ? sharedItems : window.AhfWishlist.getAll();

  if (!items.length) {
    grid.innerHTML = '';
    if (emptyState) emptyState.hidden = isSharedView; // don't show "browse" CTA on an empty/broken shared link
    return;
  }

  if (emptyState) emptyState.hidden = true;

  grid.innerHTML = items
    .map((item) => {
      const actionButton = isSharedView
        ? `<button type="button" class="wishlist-card__save" data-save-id="${item.id}" data-item='${JSON.stringify(item).replace(/'/g, '&#39;')}'>Save to my wishlist</button>`
        : item.variantId
        ? `<button type="button" class="wishlist-card__add" data-add-to-cart="${item.variantId}">Add to cart</button>`
        : `<a href="${item.url}" class="wishlist-card__add wishlist-card__add--link">View product</a>`;

      const removeButton = isSharedView
        ? ''
        : `<button type="button" class="wishlist-card__remove" aria-label="Remove from wishlist" data-remove-id="${item.id}">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>`;

      return `
      <div class="wishlist-card" data-wishlist-card="${item.id}">
        ${removeButton}
        <a href="${item.url}" class="wishlist-card__image-link">
          <img class="wishlist-card__image" src="${item.image}" alt="${item.title}" loading="lazy">
        </a>
        <a href="${item.url}" class="wishlist-card__title">${item.title}</a>
        <div class="wishlist-card__price">${formatMoney(item.price)}</div>
        ${actionButton}
      </div>
    `;
    })
    .join('');
}

function formatMoney(cents) {
  // Basic fallback formatter; swap for Shopify.formatMoney if theme exposes it.
  const amount = (Number(cents) / 100).toFixed(2);
  return `$${amount}`;
}

// ---- Share button ----

async function shortenUrl(longUrl) {
  try {
    const res = await fetch(`https://is.gd/create.php?format=json&url=${encodeURIComponent(longUrl)}`);
    if (!res.ok) throw new Error('Shortener request failed');
    const data = await res.json();
    if (data.shorturl) return data.shorturl;
    throw new Error(data.errormessage || 'No short URL returned');
  } catch (err) {
    console.warn('Could not shorten wishlist link, using full URL instead:', err);
    return longUrl; // graceful fallback — the long link still works fine
  }
}

async function shareWishlist(shareBtn) {
  if (!window.AhfWishlist) return;
  const items = window.AhfWishlist.getAll();

  if (!items.length) {
    alert('Add something to your wishlist before sharing it.');
    return;
  }

  const originalText = shareBtn ? shareBtn.textContent : null;
  if (shareBtn) {
    shareBtn.disabled = true;
    shareBtn.textContent = 'Creating link...';
  }

  const encoded = encodeShareData(items);
  const longUrl = `${window.location.origin}${window.location.pathname}?shared=${encoded}`;

  if (longUrl.length > 1800) {
    console.warn('Wishlist share link is long — some email clients may truncate it.');
  }

  const shortUrl = await shortenUrl(longUrl);

  if (shareBtn) {
    shareBtn.disabled = false;
    shareBtn.textContent = originalText;
  }

  showShareLink(shortUrl);

  const subject = encodeURIComponent('Check out my wishlist');
  const body = encodeURIComponent(`I put together a wishlist — take a look: ${shortUrl}`);
  openMailClient(`mailto:?subject=${subject}&body=${body}`);
}

function openMailClient(mailtoUrl) {
  // Using window.location.href here would navigate the CURRENT tab to the
  // mailto: URI, which can blank out or reset the page's JS state in some
  // browsers. Opening it via a temporary target="_blank" link instead keeps
  // this tab fully intact — the email client opens separately (as its own
  // app or a new tab), and this page is untouched.
  const link = document.createElement('a');
  link.href = mailtoUrl;
  link.target = '_blank';
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function showShareLink(url) {
  const box = document.querySelector('.wishlist-page [ref="shareLinkBox"]');
  const anchor = document.querySelector('.wishlist-page [ref="shareLinkAnchor"]');
  if (!box || !anchor) {
    console.warn('Share link box or anchor not found in DOM');
    return;
  }

  console.log('Setting share link:', url);

  anchor.href = url;
  anchor.textContent = 'View shared wishlist link →'; // masked — real URL still opens on click
  anchor.style.color = '#000000';
  anchor.style.fontWeight = '600';
  anchor.style.fontSize = '0.875rem';
  anchor.style.textDecoration = 'underline';
  anchor.style.flex = '1';

  box.style.display = 'flex';
  box.style.alignItems = 'center';
}

// ---- Event handling ----

document.addEventListener('click', (event) => {
  const removeBtn = event.target.closest('[data-remove-id]');
  if (removeBtn && window.AhfWishlist) {
    window.AhfWishlist.remove(removeBtn.dataset.removeId);
    return;
  }

  const addBtn = event.target.closest('[data-add-to-cart]');
  if (addBtn) {
    addToCart(addBtn);
    return;
  }

  const saveBtn = event.target.closest('[data-save-id]');
  if (saveBtn && window.AhfWishlist) {
    try {
      const item = JSON.parse(saveBtn.dataset.item.replace(/&#39;/g, "'"));
      window.AhfWishlist.add(item);
      saveBtn.textContent = 'Saved ✓';
      saveBtn.disabled = true;
    } catch (err) {
      console.error('Could not save shared item:', err);
    }
    return;
  }

  const shareBtn = event.target.closest('[ref="shareBtn"]');
  if (shareBtn) {
    shareWishlist(shareBtn);
    return;
  }

  const copyBtn = event.target.closest('[ref="shareCopyBtn"]');
  if (copyBtn) {
    const anchor = document.querySelector('.wishlist-page [ref="shareLinkAnchor"]');
    if (anchor && anchor.href) {
      navigator.clipboard
        .writeText(anchor.href)
        .then(() => {
          const original = copyBtn.textContent;
          copyBtn.textContent = 'Copied ✓';
          setTimeout(() => (copyBtn.textContent = original), 1500);
        })
        .catch(() => {
          alert('Could not copy automatically — select and copy the link manually.');
        });
    }
  }
});

async function addToCart(button) {
  const variantId = button.dataset.addToCart;
  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'Adding...';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }

    button.textContent = 'Added ✓';
    setTimeout(() => {
      window.location.href = '/cart';
    }, 700);
  } catch (err) {
    console.error('Add to cart failed:', err);
    button.disabled = false;
    button.textContent = originalText;
    alert('Sorry, that item could not be added to your cart. It may be out of stock.');
  }
}

document.addEventListener('wishlist:change', renderWishlistPage);

if (window.AhfWishlist) {
  renderWishlistPage();
} else {
  document.addEventListener('DOMContentLoaded', renderWishlistPage);
}